import { Routes } from '@angular/router';
import { farmerActionGuard } from '../utils/farmer-action.guard';
import { CampaignEditComponent } from '../pages/campaign/campaign-edit.component';
import { CampaignComponent } from '../pages/campaign/campaigns.component';
import { ExportsComponent } from '../pages/exports/exports';
import { FarmEditComponent } from '../pages/farm/farm-edit.component';
import { FarmComponent } from '../pages/farm/farms.component';
import { HelpComponent } from '../pages/help/help';
import { HomeComponent } from '../pages/home/home';
import { MachinismComponent } from '../pages/machinism/machinism';
import { MeEditComponent } from '../pages/me/me-edit.component';
import { OrganisationEditComponent } from '../pages/organisation/organisation-edit.component';
import { OrganisationComponent } from '../pages/organisation/organisations.component';
import { ParcelEditComponent } from '../pages/parcel/parcel-edit.component';
import { ParcelComponent } from '../pages/parcel/parcels.component';
import { PlanningChoiceComponent } from '../pages/planning/planning-choice.component';
import { PlanningComponent } from '../pages/planning/planning.component';
import { PlanningCalendar } from '../pages/planning/planning-visualizer/planning-calendar.component';
import { ARBleAdminComponent } from '../pages/tool/agrorendement/ble/admin.component';
import { ARBleCampaignConfigurationEditComponent } from '../pages/tool/agrorendement/ble/campaign-config-edit.component';
import { ARBleCampaignEmailComponent } from '../pages/tool/agrorendement/ble/campaign-email.component';
import { ARBleCampaignComponent } from '../pages/tool/agrorendement/ble/campaigns.component';
import { ARBleGenConsoleComponent } from '../pages/tool/agrorendement/ble/genconsole.component';
import { ARBleOrderEditComponent } from '../pages/tool/agrorendement/ble/order-edit.component';
import { ARBleOrderItemEditComponent } from '../pages/tool/agrorendement/ble/orderItem-edit.component';
import { ARBleOrderComponent } from '../pages/tool/agrorendement/ble/orders.component';
import { ARBleParcelComponent } from '../pages/tool/agrorendement/ble/parcels.component';
import { ARBleResultsComponent } from '../pages/tool/agrorendement/ble/results.component';
import { ARColzaCampaignConfigurationEditComponent } from '../pages/tool/agrorendement/colza/campaign-config-edit.component';
import { ARColzaCampaignComponent } from '../pages/tool/agrorendement/colza/campaigns.component';
import { ARColzaGenConsoleComponent } from '../pages/tool/agrorendement/colza/genconsole.component';
import { ARColzaOrderEditComponent } from '../pages/tool/agrorendement/colza/order-edit.component';
import { ARColzaOrderItemEditComponent } from '../pages/tool/agrorendement/colza/orderItem-edit.component';
import { ARColzaOrderComponent } from '../pages/tool/agrorendement/colza/orders.component';
import { ARColzaParcelComponent } from '../pages/tool/agrorendement/colza/parcels.component';
import { ARColzaResultsComponent } from '../pages/tool/agrorendement/colza/results.component';
import { AROrgeCampaignConfigurationEditComponent } from '../pages/tool/agrorendement/orge/campaign-config-edit.component';
import { AROrgeCampaignComponent } from '../pages/tool/agrorendement/orge/campaigns.component';
import { AROrgeGenConsoleComponent } from '../pages/tool/agrorendement/orge/genconsole.component';
import { AROrgeOrderEditComponent } from '../pages/tool/agrorendement/orge/order-edit.component';
import { AROrgeOrderItemEditComponent } from '../pages/tool/agrorendement/orge/orderItem-edit.component';
import { AROrgeOrderComponent } from '../pages/tool/agrorendement/orge/orders.component';
import { AROrgeParcelComponent } from '../pages/tool/agrorendement/orge/parcels.component';
import { AROrgeResultsComponent } from '../pages/tool/agrorendement/orge/results.component';
import { OrderComponent } from '../pages/tool/order.component';
import { ResultComponent } from '../pages/tool/result.component';
import { ZSNCampaignConfigurationEditComponent } from '../pages/tool/zsn/campaign-config-edit.component';
import { ZSNCampaignComponent } from '../pages/tool/zsn/campaigns.component';
import { ZSNOrderEditComponent } from '../pages/tool/zsn/order-edit.component';
import { ZSNOrderItemEditComponent } from '../pages/tool/zsn/orderItem-edit.component';
import { ZSNOrderComponent } from '../pages/tool/zsn/orders.component';
import { ZSNParcelComponent } from '../pages/tool/zsn/parcels.component';
import { ZSNResultsComponent } from '../pages/tool/zsn/results.component';
import { UserEditComponent } from '../pages/user/user-edit.component';
import { UserComponent } from '../pages/user/users.component';
import { SSOGuard } from '../services/sso.service';
import { FieldviewLink } from '../pages/fieldviewLink/fieldviewLink';
import { PlanningSelectParcel } from '../pages/planning/planning-parcel.component';
import { ChartDashboard } from '../pages/dashboard/chart-dashboard.component';

export const dashboardRoutes: Routes = [
  { path: 'home', component: HomeComponent, canActivate: [SSOGuard] },
  { path: 'help', component: HelpComponent },
  { path: 'campaigns', component: CampaignComponent },
  { path: 'campaigns/new', component: CampaignEditComponent },
  { path: 'campaigns/edit/:campaignId', component: CampaignEditComponent },
  { path: 'farms', component: FarmComponent },
  { path: 'farms/new', component: FarmEditComponent, canActivate: [farmerActionGuard('createFarm', '/farms')] },
  { path: 'farms/edit/:farmId', component: FarmEditComponent },
  { path: 'organisations', component: OrganisationComponent },
  { path: 'organisations/new', component: OrganisationEditComponent },
  { path: 'organisations/edit/:organisationId', component: OrganisationEditComponent },
  { path: 'parcels', component: ParcelComponent },
  { path: 'parcels/new', component: ParcelEditComponent, canActivate: [farmerActionGuard('createParcel', '/parcels')] },
  {
    path: 'parcels/new/:campaignId',
    component: ParcelEditComponent,
    canActivate: [farmerActionGuard('createParcel', '/parcels')],
  },
  {
    path: 'parcels/new/:campaignId/:parcelId',
    component: ParcelEditComponent,
    canActivate: [farmerActionGuard('createParcel', '/parcels')],
  },
  {
    path: 'parcels/edit/:parcelId',
    component: ParcelEditComponent,
    canActivate: [farmerActionGuard('editParcel', '/parcels')],
  },
  { path: 'users', component: UserComponent },
  { path: 'users/new', component: UserEditComponent },
  { path: 'users/edit/me', component: MeEditComponent },
  { path: 'users/edit/:userId', component: UserEditComponent },
  { path: 'machinism', component: MachinismComponent },
  { path: 'exports', component: ExportsComponent },
  { path: 'planning', component: PlanningComponent },
  { path: 'planning/:culture', component: PlanningChoiceComponent },
  { path: 'visualizer/calendar', component: PlanningCalendar },
  { path: 'orders', component: OrderComponent },
  { path: 'results', component: ResultComponent },
  { path: 'fieldviewLink', component: FieldviewLink },
  { path: 'planning-parcel', component: PlanningSelectParcel },
  { path: 'dashboard', component: ChartDashboard },

  // AR Colza
  { path: 'orders/azote/colza/admin', component: ARColzaCampaignComponent },
  { path: 'orders/azote/colza/parcels', component: ARColzaParcelComponent },
  { path: 'orders/azote/colza/parcels/:parcelId', component: ARColzaOrderItemEditComponent },
  { path: 'orders/azote/colza/parcels/edit/:parcelId', component: ARColzaOrderItemEditComponent },
  { path: 'orders/azote/colza/parcels/batch/:parcelIds', component: ARColzaOrderItemEditComponent },
  { path: 'orders/azote/colza/orders', component: ARColzaOrderComponent },
  { path: 'orders/azote/colza/orders/new', component: ARColzaOrderEditComponent },
  { path: 'orders/azote/colza/orders/new/:parcelId', component: ARColzaOrderEditComponent },
  { path: 'orders/azote/colza/orders/edit/:orderId', component: ARColzaOrderEditComponent },
  { path: 'orders/azote/colza/orders/view/:orderId', component: ARColzaOrderEditComponent },
  { path: 'orders/azote/colza/admin/new/:campaignId', component: ARColzaCampaignConfigurationEditComponent },
  { path: 'orders/azote/colza/admin/edit/:configId', component: ARColzaCampaignConfigurationEditComponent },
  { path: 'results/azote/colza', component: ARColzaResultsComponent },
  { path: 'results/azote/colza/genconsole', component: ARColzaGenConsoleComponent },

  // AR Ble
  { path: 'orders/azote/ble/admin', component: ARBleAdminComponent },
  { path: 'orders/azote/ble/admin/campaigns', component: ARBleCampaignComponent },
  { path: 'orders/azote/ble/admin/campaigns/new/:campaignId', component: ARBleCampaignConfigurationEditComponent },
  { path: 'orders/azote/ble/admin/campaigns/edit/:configId', component: ARBleCampaignConfigurationEditComponent },
  { path: 'orders/azote/ble/admin/emails', component: ARBleCampaignEmailComponent },
  { path: 'orders/azote/ble/parcels', component: ARBleParcelComponent },
  { path: 'orders/azote/ble/parcels/:parcelId', component: ARBleOrderItemEditComponent },
  { path: 'orders/azote/ble/parcels/edit/:parcelId', component: ARBleOrderItemEditComponent },
  { path: 'orders/azote/ble/parcels/batch/:parcelIds', component: ARBleOrderItemEditComponent },
  { path: 'orders/azote/ble/orders', component: ARBleOrderComponent },
  { path: 'orders/azote/ble/orders/new', component: ARBleOrderEditComponent },
  { path: 'orders/azote/ble/orders/new/:parcelId', component: ARBleOrderEditComponent },
  { path: 'orders/azote/ble/orders/edit/:orderId', component: ARBleOrderEditComponent },
  { path: 'orders/azote/ble/orders/view/:orderId', component: ARBleOrderEditComponent },
  { path: 'results/azote/ble', component: ARBleResultsComponent },
  { path: 'results/azote/ble/genconsole', component: ARBleGenConsoleComponent },

  // AR Orge
  { path: 'orders/azote/orge/admin', component: AROrgeCampaignComponent },
  { path: 'orders/azote/orge/parcels', component: AROrgeParcelComponent },
  { path: 'orders/azote/orge/parcels/:parcelId', component: AROrgeOrderItemEditComponent },
  { path: 'orders/azote/orge/parcels/edit/:parcelId', component: AROrgeOrderItemEditComponent },
  { path: 'orders/azote/orge/parcels/batch/:parcelIds', component: AROrgeOrderItemEditComponent },
  { path: 'orders/azote/orge/orders', component: AROrgeOrderComponent },
  { path: 'orders/azote/orge/orders/new', component: AROrgeOrderEditComponent },
  { path: 'orders/azote/orge/orders/new/:parcelId', component: AROrgeOrderEditComponent },
  { path: 'orders/azote/orge/orders/edit/:orderId', component: AROrgeOrderEditComponent },
  { path: 'orders/azote/orge/orders/view/:orderId', component: AROrgeOrderEditComponent },
  { path: 'orders/azote/orge/admin/new/:campaignId', component: AROrgeCampaignConfigurationEditComponent },
  { path: 'orders/azote/orge/admin/edit/:configId', component: AROrgeCampaignConfigurationEditComponent },
  { path: 'results/azote/orge', component: AROrgeResultsComponent },
  { path: 'results/azote/orge/genconsole', component: AROrgeGenConsoleComponent },

  // ZSN
  { path: 'orders/zsn/admin', component: ZSNCampaignComponent },
  { path: 'orders/zsn/parcels', component: ZSNParcelComponent },
  { path: 'orders/zsn/parcels/:parcelId', component: ZSNOrderItemEditComponent },
  { path: 'orders/zsn/parcels/edit/:parcelId', component: ZSNOrderItemEditComponent },
  { path: 'orders/zsn/parcels/batch/:parcelIds', component: ZSNOrderItemEditComponent },
  { path: 'orders/zsn/orders', component: ZSNOrderComponent },
  {
    path: 'orders/zsn/orders/new',
    component: ZSNOrderEditComponent,
    canActivate: [farmerActionGuard('createOrder', '/orders/zsn/parcels')],
  },
  {
    path: 'orders/zsn/orders/new/:parcelId',
    component: ZSNOrderEditComponent,
    canActivate: [farmerActionGuard('createOrder', '/orders/zsn/parcels')],
  },
  { path: 'orders/zsn/orders/edit/:orderId', component: ZSNOrderEditComponent },
  { path: 'orders/zsn/orders/view/:orderId', component: ZSNOrderEditComponent },
  { path: 'orders/zsn/admin/new/:campaignId', component: ZSNCampaignConfigurationEditComponent },
  { path: 'orders/zsn/admin/edit/:configId', component: ZSNCampaignConfigurationEditComponent },
  { path: 'results/zsn', component: ZSNResultsComponent },

  // catch-all
  { path: '**', redirectTo: '/home' },
];
